<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between gap-2">
    <div class="text-base font-bold">Checklist</div>
    <a href="javascript:void(0);" (click)="openChecklistForm()">Edit</a>
  </div>
  <pr-appointment-checklist-items [checklistItems]="checklistItems$ | async" />
</div>
